// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QaOL","col":"styles_col__2DDT8"};